<script lang="ts">
    let twitter = './assets/img/logo-twitter.svg';
    let name = 'BarFight';
</script>


<nav>
    <div class="nav-container">
        <a id="branding" href="/">{name}</a>

        <ul class="nav">
            <li class="nav_item">
                <a href="/">Home</a>
            </li>
            <li class="nav_item">
                <a href="#story">Story</a>
            </li>
            <li class="nav_item">
                <a href="#roadmap">Roadmap</a>
            </li>
            <li class="nav_item">
                <a href="#characters">Characters</a>
            </li>
        </ul>

        <ul class="social">
            <li class="social_item">
                <a href="https://twitter.com/barfightgame" target="_blank" rel="noreferrer">
                    <img src={twitter} alt="Discord" />
                </a>
            </li>
        </ul>
    </div>
</nav>

<style type="text/scss">
    nav {
        margin: 0 1rem;
        padding: 2rem 0;
    }

    .nav-container {
        align-items: center;
        display: flex;
        justify-content: center;

        #branding {
            color: white;
            margin-right: auto;
            font-family: var(--font-header);
            font-size: 1.5rem;

            &:hover {
                color: var(--color-highlight);
            }
        }

        ul.nav {
            display: flex;
            font-family: var(--font-header);
            flex-direction: row;
            list-style-type: none;
            text-align: center;

            li.nav_item:not(:last-child) {
                margin: 0 2rem 0 0;
            }
        }

        ul.social {
            list-style-type: none;
            margin-left: auto;

            li.social_item a {
                border-bottom: none;

                > img {
                    width: 28px; height: 28px;
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        nav {
            margin: 0 2rem;
            padding: 4rem 0;
        }
    }
</style>